// extracted by mini-css-extract-plugin
export default {"hoverEffect":"CartIcon_hoverEffect__9cLMF","cartIcon":"CartIcon_cartIcon__q3KS8","cartNb":"CartIcon_cartNb__PqUub"};